/**
 * 用量管理模块路由配置
 */
import type { RouteRecordRaw } from 'vue-router'
import { Permission } from '@/utils/permission'
import { UsageManagement } from '@/modules/usage/views'
import { UsageHistory } from '@/modules/usage/views'

const usageRoutes: RouteRecordRaw[] = [
  // 用量管理（系统管理下）
  {
    path: 'usage',
    name: 'UsageManagement',
    component: UsageManagement,
    meta: {
      title: '用量管理',
      requiresAuth: true,
      permissions: [Permission.SYSTEM_USAGE],
      breadcrumb: true
    }
  },
  // 消费记录（个人中心下，壳层，仅需登录）
  {
    path: 'usage-history',
    name: 'UsageHistory',
    component: UsageHistory,
    meta: {
      titleKey: 'menu.consumptionRecords',
      title: '消费记录',
      requiresAuth: true,
      breadcrumb: true
    }
  }
]

export default usageRoutes

